import React from "react";

export default function TermsAndConditions() {
  return (
    <>
      <h1>Terms and Conditions</h1>
      <div className="left-align-text" style={{ padding: 100 }}>
        <h4 className="font-weight-normal">Last updated: May 2025</h4>
        <h3 className="paddingtop20">1. Introduction</h3>
        <div className="fa-left-padding paddingtop20">
          <p>
            Welcome to <b>Head3d</b> (“Company”, “we”, “our”, “us”)!
          </p>
          <p>
            These Terms of Service (“Terms”, “Terms of Service”) govern your use
            of our website located at <b>head3dio.com</b> (together or
            individually “Service”) operated by <b>Head3d</b>.
          </p>
          <p>
            Our Privacy Policy also governs your use of our Service and explains
            how we collect, safeguard and disclose information that results from
            your use of our web pages.
          </p>
          <p>
            Your agreement with us includes these Terms and our Privacy Policy
            (“Agreements”). You acknowledge that you have read and understood
            Agreements, and agree to be bound of them.
          </p>
          <p>
            If you do not agree with (or cannot comply with) Agreements, then
            you may not use the Service, but please let us know by emailing at{" "}
            <b>contact@head3dio.com</b> so we can try to find a solution. These
            Terms apply to all visitors, users and others who wish to access or
            use Service.
          </p>
          <div className="fa-left-padding paddingtop20">
            Definitions
            <div className="fa-left-padding paddingtop20">
              Plan - A paid membership that allows customers to access services
              provided by Head3d. A Plan may or may not include a Free Trial and
              may be eligible for discount (spanning over few months or entire
              duration of membership).
            </div>
          </div>
        </div>
        <h3 className="paddingtop20">
          2. <b>Communications</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          <p>
            By using our Service, you agree to subscribe to newsletters,
            marketing or promotional materials and other information we may
            send. However, you may opt out of receiving any, or all, of these
            communications from us by following the unsubscribe link or by
            emailing at <b>contact@head3dio.com</b>.
          </p>
        </div>
        <h3 className="paddingtop20">
          3. <b>Contests, Sweepstakes and Promotions</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          <p>
            Any contests, sweepstakes or other promotions (collectively,
            “Promotions”) made available through Service may be governed by
            rules that are separate from these Terms of Service. If you
            participate in any Promotions, please review the applicable rules as
            well as our Privacy Policy. If the rules for a Promotion conflict
            with these Terms of Service, Promotion rules will apply.
          </p>
        </div>
        <h3 className="paddingtop20">
          4. <b>Content</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          <p>
            Content found on or through this Service are the property of Head3d
            or used with permission. You may not distribute, modify, transmit,
            reuse, download, repost, copy, or use said Content, whether in whole
            or in part, for commercial purposes or for personal gain, without
            express advance written permission from us. The content (e.g. 3D
            environments/backgrounds) available on this website may not be
            accessable to all customers and is subject to availablity.
          </p>
        </div>
        <h3 className="paddingtop20">
          5. <b>Prohibited Uses</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          <p>
            You may use Service only for lawful purposes and in accordance with
            Terms. You agree not to use Service:
          </p>
          <div className="fa-left-padding paddingtop20">
            <p>
              0.1. In any way that violates any applicable national or
              international law or regulation.
            </p>
            <p>
              0.2. For the purpose of exploiting, harming, or attempting to
              exploit or harm minors in any way by exposing them to
              inappropriate content or otherwise.
            </p>
            <p>
              0.3. To transmit, or procure the sending of, any advertising or
              promotional material, including any “junk mail”, “chain letter,”
              “spam,” or any other similar solicitation.
            </p>
            <p>
              0.4. To impersonate or attempt to impersonate Company, a Company
              employee, another user, or any other person or entity.
            </p>
            <p>
              0.5. In any way that infringes upon the rights of others, or in
              any way is illegal, threatening, fraudulent, or harmful, or in
              connection with any unlawful, illegal, fraudulent, or harmful
              purpose or activity.
            </p>
            <p>
              0.6. To engage in any other conduct that restricts or inhibits
              anyone’s use or enjoyment of Service, or which, as determined by
              us, may harm or offend Company or users of Service or expose them
              to liability.
            </p>
          </div>
          <p className="paddingtop20">Additionally, you agree not to:</p>
          <div className="fa-left-padding paddingtop20">
            <p>
              1.1. Use Service in any manner that could disable, overburden,
              damage, or impair Service or interfere with any other party’s use
              of Service, including their ability to engage in real time
              activities through Service.
            </p>
            <p>
              1.2. Use any robot, spider, or other automatic device, process, or
              means to access Service for any purpose, including monitoring or
              copying any of the material on Service.
            </p>
            <p>
              1.3. Use any manual process to monitor or copy any of the material
              on Service or for any other unauthorized purpose without our prior
              written consent.
            </p>
            <p>
              1.4. Use any device, software, or routine that interferes with the
              proper working of Service.
            </p>
            <p>
              1.5. Introduce any viruses, trojan horses, worms, logic bombs, or
              other material which is malicious or technologically harmful.
            </p>
            <p>
              1.6. Attempt to gain unauthorized access to, interfere with,
              damage, or disrupt any parts of Service, the server on which
              Service is stored, or any server, computer, or database connected
              to Service.
            </p>
            <p>
              1.7. Attack Service via a denial-of-service attack or a
              distributed denial-of-service attack.
            </p>
            <p>
              1.8. Take any action that may damage or falsify Company rating.
            </p>
            <p>
              1.9. Otherwise attempt to interfere with the proper working of
              Service.
            </p>
          </div>
        </div>
        <h3 className="paddingtop20">
          6. <b>Subscription and Payment Policy</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          0.1. Subscription Terms - Head3d offers a range of subscription Plans
          to its services (each, a "Plan"). You will select a Plan as part of
          your registration to access services, which may begin with a Free
          Trial. Each subscription period for a Plan will be based on
          subscription period chosen (e.g. anually, bi-anually, quarterly,
          monthly). Regardless of your billing cycle, you are responsible for
          your subscription fees for your entire subscription period
          chosen/sold. This includes maintaining a valid credit or debit card,
          with eligible funds, accepted by our payment systems via the
          subscription management portal or by contacting us at{" "}
          <b>contact@head3dio.com</b>.
        </div>
        <div className="fa-left-padding paddingtop20">
          Head3d is service offering 3D experices to customers. We are aware
          that you may not be able to use our services immediately upon
          subscription or during Free Trial period since it has a dependency on
          having a VR headset available to you. You may be able to add a VR
          headset during the checkout process (subject to availability). It is
          likely that you will be able to purchace a mobile-compatible headset
          for cheaper via other sources. We try our best to ensure prompt
          delivery of the VR headset to the shipping address you provide during
          checkout process. Refer to Shipping Policy defined in section 7.0.1.
        </div>
        <div className="fa-left-padding paddingtop20">
          At the end of your current subscription period your Plan will
          automatically renew for a new period equal to your prior subscription
          period unless you choose an alternative subscription Plan (downgrade
          or upgrade) or you provide Head3d notice of your intent not to renew
          your Plan atleast thirty (30) days prior to the end of the
          then-current subscription period. If you cancel your Plan before the
          end of your current subscription period, you will not be charged again
          for your Plan begining with the next billing cycle. If your paymant
          fails we may retry collection of payment. If all retries for a payment
          fail, we will cancel your then-current subscription and you will loose
          access the services. Any discounts applied to a previous subscription
          may not apply to a new subscription, including any automatic renewals.
        </div>
        <div className="fa-left-padding paddingtop20">
          If you participate in a Free Trial period, you may have to cancel the
          service by the end of the Free Trial period to avoid incurring any
          charges. If you do not cancel before Free Trial period expires, you
          authorize us to charge your credit/debit card the full cost of your
          Plan which will then continue to renew at the billing cycle selected
          until cancelled.
        </div>
        <div className="fa-left-padding paddingtop20">
          0.2. Changes in Fees - We may change the fees for services at any time
          or impose additional fees or charges
        </div>
        <div className="fa-left-padding paddingtop20">
          0.3. Payment processing - We use thrid party servces as means to
          process your payments. Some information you provide will be passed to
          these third party services to process payment, send invoices or inform
          you of relavant payment information. We do not collect, store or
          process credit or debit card information (including billing
          information) on our servers. We are not liable for any mishandling of
          payment information provided to these third party services (including
          in the event of a data breach).
        </div>
        <h3 className="paddingtop20">
          7. <b>Goods Shipping and Returns Policy</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          0.1. Shipping Region - We currently only ship goods to EU regions and
          North America
        </div>
        <div className="fa-left-padding paddingtop20">
          0.2. VR Headset as part of Head3d Subscription - We offer a standard
          free delivery option on all subscriptions regardless of the Plan
          chosen by you. The Company has the right to choose the Headset we
          provide to customers. Additionally, shipping address must be in the
          region defined in Section 7.0.1. If the shipping/delivery was claimed
          to be unsuccessfull by the customer, we have the right not to resend
          another VR headset - as long as we have proof that the delivery was
          attempted. The Company may refuse to send a VR Headset (1) if the
          shipping address is not eligible according to Section 7.0.1. In this
          case, a full refund for the VR headset will be made to you.
        </div>
        <div className="paddingtop20">
          Returns Policy
          <div className="fa-left-padding paddingtop20">
            1.1. Returns Policy on VR Headset - You may inform us on your intend
            to return your Headset within ten (10) Days of delivery. If you are
            returning the headset to recieve refund for the item then we will
            inspect the returned goods for damages. We may only give a partial
            refund or no refund depending on the damages to item. If you are
            looking for a replacement VR headset due to damage on delivery you
            will need to provide us photo evidence within three (3) days of
            delivery. Upon receiving the returned headset we will ship you a
            replacement.
          </div>
        </div>
        <h3 className="paddingtop20">
          8. <b>Video Content Streaming Policy</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          Any video content streamed using our Services are not managed by our
          servers. In some instances, we use peer-to-peer connection to ensure
          video stream content is confidential. We do not monitor, interfere or
          control any video streaming data and will not be held liable for any
          misconduct or harm. We may use third party services to aid the content
          streaming to enhance performance and functionality
        </div>
        <h3 className="paddingtop20">
          9. <b>Analytics</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          We may use third-party Service Providers to monitor and analyze the
          use of our Service.
        </div>
        <h3 className="paddingtop20">
          10. <b>No Use By Minors</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          Service is intended only for access and use by individuals at least
          eighteen (18) years old. By accessing or using Service, you warrant
          and represent that you are at least eighteen (18) years of age and
          with the full authority, right, and capacity to enter into this
          agreement and abide by all of the terms and conditions of Terms. If
          you are not at least eighteen (18) years old, you are prohibited from
          both the access and usage of Service. we do not knowingly collect any
          personal data from, children or teenagers under the age of eighteen
          (18). If you are under the age of 18, you may only use this Site under
          the supervision of your parents or guardians.
        </div>
        <h3 className="paddingtop20">
          11. <b>Account </b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          <p>
            When you create an account with us, you guarantee that you are above
            the age of 18, and that the information you provide us is accurate,
            complete, and current at all times. Inaccurate, incomplete, or
            obsolete information may result in the immediate termination of your
            account on Service.
          </p>
          <p>
            You are responsible for maintaining the confidentiality of your
            account and password, including but not limited to the restriction
            of access to your computer and/or account. You agree to accept
            responsibility for any and all activities or actions that occur
            under your account and/or password, whether your password is with
            our Service or a third-party service. You must notify us immediately
            upon becoming aware of any breach of security or unauthorized use of
            your account.
          </p>
          <p>
            You may not use an email address in the name of another person or
            entity or that is not lawfully available for use. The email address
            you use to create an account must not be a temporary email address
            and must be from a valid email service provier.
          </p>
          <p>
            We reserve the right to refuse service, terminate accounts, remove
            or edit content, or cancel orders in our sole discretion.
          </p>
        </div>
        <h3 className="paddingtop20">
          12. <b>Intellectual Property</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          Service and its original content (excluding Content provided by
          users), features and functionality are and will remain the exclusive
          property of Head3d and its licensors. Service may be protected by
          copyright, trademark, and other laws of and foreign countries. Our
          trademarks may not be used in connection with any product or service
          without the prior written consent of Head3d.
        </div>

        <h3 className="paddingtop20">
          13. <b>Copyright Policy</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          <p>
            We respect the intellectual property rights of others. It is our
            policy to respond to any claim that Content posted on Service
            infringes on the copyright or other intellectual property rights
            (“Infringement”) of any person or entity.
          </p>
          <p>
            If you are a copyright owner, or authorized on behalf of one, and
            you believe that the copyrighted work has been copied in a way that
            constitutes copyright infringement, please submit your claim via
            email to <b>contact@head3dio.com</b>, with the subject line:
            “Copyright Infringement” and include in your claim a detailed
            description of the alleged Infringement as detailed below, under
            “DMCA Notice and Procedure for Copyright Infringement Claims”
          </p>
          <p>
            You may be held accountable for damages (including costs and
            attorneys’ fees) for misrepresentation or bad-faith claims on the
            infringement of any Content found on and/or through Service on your
            copyright.
          </p>
        </div>
        <h3 className="paddingtop20">
          14. <b>DMCA Notice and Procedure for Copyright Infringement Claims</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          <p>
            You may submit a notification pursuant to the Digital Millennium
            Copyright Act (DMCA) by providing our Copyright Agent with the
            following information in writing (see 17 U.S.C 512(c)(3) for further
            detail):
          </p>
          <div className="fa-left-padding paddingtop20">
            <p>
              0.1. an electronic or physical signature of the person authorized
              to act on behalf of the owner of the copyright’s interest;
            </p>
            <p>
              0.2. a description of the copyrighted work that you claim has been
              infringed, including the URL (i.e., web page address) of the
              location where the copyrighted work exists or a copy of the
              copyrighted work;
            </p>
            <p>
              0.3. identification of the URL or other specific location on
              Service where the material that you claim is infringing is
              located;
            </p>
            <p>0.4. your address, telephone number, and email address;</p>
            <p>
              0.5. a statement by you that you have a good faith belief that the
              disputed use is not authorized by the copyright owner, its agent,
              or the law;
            </p>
            <p>
              0.6. a statement by you, made under penalty of perjury, that the
              above information in your notice is accurate and that you are the
              copyright owner or authorized to act on the copyright owner’s
              behalf.
            </p>
            <p>
              You can contact our Copyright Agent via email at
              <b> contact@head3dio.com.</b>
            </p>
          </div>
        </div>
        <h3 className="paddingtop20">
          15. <b>Error Reporting and Feedback</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          You may provide us either directly at <b>contact@head3dio.com</b> or
          via third party sites and tools with information and feedback
          concerning errors, suggestions for improvements, ideas, problems,
          complaints, and other matters related to our Service (“Feedback”). You
          acknowledge and agree that: (i) you shall not retain, acquire or
          assert any intellectual property right or other right, title or
          interest in or to the Feedback; (ii) Company may have development
          ideas similar to the Feedback; (iii) Feedback does not contain
          confidential information or proprietary information from you or any
          third party; and (iv) Company is not under any obligation of
          confidentiality with respect to the Feedback. In the event the
          transfer of the ownership to the Feedback is not possible due to
          applicable mandatory laws, you grant Company and its affiliates an
          exclusive, transferable, irrevocable, free-of-charge, sub-licensable,
          unlimited and perpetual right to use (including copy, modify, create
          derivative works, publish, distribute and commercialize) Feedback in
          any manner and for any purpose.
        </div>
        <h3 className="paddingtop20">
          16. <b>Links To Other Web Sites</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          <p>
            Our Service may contain links to third party web sites or services
            that are not owned or controlled by Head3d.
          </p>
          <p>
            Head3d has no control over, and assumes no responsibility for the
            content, privacy policies, or practices of any third party web sites
            or services. We do not warrant the offerings of any of these
            entities/individuals or their websites.
          </p>
          <p>
            YOU ACKNOWLEDGE AND AGREE THAT COMPANY SHALL NOT BE RESPONSIBLE OR
            LIABLE, DIRECTLY OR INDIRECTLY, FOR ANY DAMAGE OR LOSS CAUSED OR
            ALLEGED TO BE CAUSED BY OR IN CONNECTION WITH USE OF OR RELIANCE ON
            ANY SUCH CONTENT, GOODS OR SERVICES AVAILABLE ON OR THROUGH ANY SUCH
            THIRD PARTY WEB SITES OR SERVICES.
          </p>
          <p>
            WE STRONGLY ADVISE YOU TO READ THE TERMS OF SERVICE AND PRIVACY
            POLICIES OF ANY THIRD PARTY WEB SITES OR SERVICES THAT YOU VISIT.
          </p>
        </div>
        <h3 className="paddingtop20">
          17. <b>Disclaimer Of Warranty</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          <p>
            THESE SERVICES ARE PROVIDED BY COMPANY ON AN “AS IS” AND “AS
            AVAILABLE” BASIS. COMPANY MAKES NO REPRESENTATIONS OR WARRANTIES OF
            ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THEIR SERVICES,
            OR THE INFORMATION, CONTENT OR MATERIALS INCLUDED THEREIN. YOU
            EXPRESSLY AGREE THAT YOUR USE OF THESE SERVICES, THEIR CONTENT, AND
            ANY SERVICES OR ITEMS OBTAINED FROM US IS AT YOUR SOLE RISK.
          </p>
          <p>
            NEITHER COMPANY NOR ANY PERSON ASSOCIATED WITH COMPANY MAKES ANY
            WARRANTY OR REPRESENTATION WITH RESPECT TO THE COMPLETENESS,
            SECURITY, RELIABILITY, QUALITY, ACCURACY, OR AVAILABILITY OF THE
            SERVICES. WITHOUT LIMITING THE FOREGOING, NEITHER COMPANY NOR ANYONE
            ASSOCIATED WITH COMPANY REPRESENTS OR WARRANTS THAT THE SERVICES,
            THEIR CONTENT, OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE
            SERVICES WILL BE ACCURATE, RELIABLE, ERROR-FREE, OR UNINTERRUPTED,
            THAT DEFECTS WILL BE CORRECTED, THAT THE SERVICES OR THE SERVER THAT
            MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS
            OR THAT THE SERVICES OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE
            SERVICES WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.
          </p>
          <p>
            COMPANY HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS
            OR IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING BUT NOT LIMITED TO
            ANY WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT, AND FITNESS FOR
            PARTICULAR PURPOSE.
          </p>
          <p>
            THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE
            EXCLUDED OR LIMITED UNDER APPLICABLE LAW.
          </p>
        </div>
        <h3 className="paddingtop20">
          18. <b>Account Termination</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          <p>
            We may terminate or suspend your account and bar access to Service
            immediately, without prior notice or liability, under our sole
            discretion, for any reason whatsoever and without limitation,
            including but not limited to a breach of Terms.
          </p>
          <p>
            If you wish to terminate your account, you may simply discontinue
            using Service. We may still hold or archive all information related
            to your account.
          </p>
          <p>
            All provisions of Terms which by their nature should survive
            termination shall survive termination, including, without
            limitation, ownership provisions, warranty disclaimers, indemnity
            and limitations of liability.
          </p>
        </div>
        <h3 className="paddingtop20">
          19. <b>Governing Law</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          <p>
            These Terms shall be governed and construed in accordance with the
            laws of United Kingdom (GB), which governing law applies to
            agreement without regard to its conflict of law provisions.
          </p>
          <p>
            Our failure to enforce any right or provision of these Terms will
            not be considered a waiver of those rights. If any provision of
            these Terms is held to be invalid or unenforceable by a court, the
            remaining provisions of these Terms will remain in effect. These
            Terms constitute the entire agreement between us regarding our
            Service and supersede and replace any prior agreements we might have
            had between us regarding Service.
          </p>
        </div>
        <h3 className="paddingtop20">
          20. <b>Changes To Service</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          We reserve the right to withdraw or amend our Service, and any service
          or material we provide via Service, in our sole discretion without
          notice. We will not be liable if for any reason all or any part of
          Service is unavailable at any time or for any period. From time to
          time, we may restrict access to some parts of Service, or the entire
          Service, to users, including registered users.
        </div>
        <h3 className="paddingtop20">
          21. <b>Amendments To Terms</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          <p>
            We may amend Terms at any time by posting the amended terms on this
            site. It is your responsibility to review these Terms periodically.
          </p>
          <p>
            Your continued use of the Platform following the posting of revised
            Terms means that you accept and agree to the changes. You are
            expected to check this page frequently so you are aware of any
            changes, as they are binding on you.
          </p>
          <p>
            By continuing to access or use our Service after any revisions
            become effective, you agree to be bound by the revised terms. If you
            do not agree to the new terms, you are no longer authorized to use
            Service.
          </p>
        </div>
        <h3 className="paddingtop20">
          22. <b>Security of Personal Data</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          We use commercially reasonable physical, technical and administrative
          security measures and safeguards to protect the confidentiality and
          security of your personal information. However, since the Internet is
          not a 100% secure environment, we cannot guarantee, ensure, or warrant
          the security of any information you transmit to us. There is no
          guarantee that information may not be accessed, disclosed, altered, or
          destroyed by breach of any of our physical, technical, or managerial
          safeguards. It is your responsibility to protect the security of your
          login information. Please note that e-mails and other communications
          you send to us through our Site are not encrypted, and we strongly
          advise you not to communicate any confidential information through
          these means.
        </div>
        <h3 className="paddingtop20">
          23. <b>Accuracy and Personal Responsibility </b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          We have done our best to ensure that the information provided on this
          website and the resources available provide valuable information, but
          cannot guarantee the accuracy of the information. Neither the company
          nor any of its owners or proprietors or employee shall be held liable
          for any errors on this website or for any damages you may suffer as a
          result.
        </div>
        <h3 className="paddingtop20">
          24. <b>Limitation of Liability </b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          <p>
            The Company has not made any guarentees about the results of taking
            any action, whether recommended on this website or by a third-party.
            We try our best run our services optimally to ensure customer
            staisfaction and epected results. However, the Services available on
            this website are directly affected by multiple third-party services
            and their availablity. In addition, services may be affected
            negatively or positively by Internet Service Provider (ISP),
            connection type, connection speed, end-users device capabilities
            etc.
          </p>
          <p className="paddingtop20">
            EXCEPT AS PROHIBITED BY LAW, YOU WILL HOLD US AND OUR OFFICERS,
            DIRECTORS, EMPLOYEES, AND AGENTS HARMLESS FOR ANY INDIRECT,
            PUNITIVE, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGE, HOWEVER IT
            ARISES (INCLUDING ATTORNEYS’ FEES AND ALL RELATED COSTS AND EXPENSES
            OF LITIGATION AND ARBITRATION, OR AT TRIAL OR ON APPEAL, IF ANY,
            WHETHER OR NOT LITIGATION OR ARBITRATION IS INSTITUTED), WHETHER IN
            AN ACTION OF CONTRACT, NEGLIGENCE, OR OTHER TORTIOUS ACTION, OR
            ARISING OUT OF OR IN CONNECTION WITH THIS AGREEMENT, INCLUDING
            WITHOUT LIMITATION ANY CLAIM FOR PERSONAL INJURY OR PROPERTY DAMAGE,
            ARISING FROM THIS AGREEMENT AND ANY VIOLATION BY YOU OF ANY FEDERAL,
            STATE, OR LOCAL LAWS, STATUTES, RULES, OR REGULATIONS, EVEN IF
            COMPANY HAS BEEN PREVIOUSLY ADVISED OF THE POSSIBILITY OF SUCH
            DAMAGE. EXCEPT AS PROHIBITED BY LAW, IF THERE IS LIABILITY FOUND ON
            THE PART OF COMPANY, IT WILL BE LIMITED TO THE AMOUNT PAID FOR THE
            PRODUCTS AND/OR SERVICES, AND UNDER NO CIRCUMSTANCES WILL THERE BE
            CONSEQUENTIAL OR PUNITIVE DAMAGES. SOME STATES DO NOT ALLOW THE
            EXCLUSION OR LIMITATION OF PUNITIVE, INCIDENTAL OR CONSEQUENTIAL
            DAMAGES, SO THE PRIOR LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU.
          </p>
        </div>
        <h3 className="paddingtop20">
          25. <b>Waiver And Severability</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          <p>
            No waiver by Company of any term or condition set forth in Terms
            shall be deemed a further or continuing waiver of such term or
            condition or a waiver of any other term or condition, and any
            failure of Company to assert a right or provision under Terms shall
            not constitute a waiver of such right or provision.
          </p>
          <p>
            If any provision of Terms is held by a court or other tribunal of
            competent jurisdiction to be invalid, illegal or unenforceable for
            any reason, such provision shall be eliminated or limited to the
            minimum extent such that the remaining provisions of Terms will
            continue in full force and effect.
          </p>
        </div>
        <h3 className="paddingtop20">
          26. <b>Acknowledgement</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          BY USING SERVICE OR OTHER SERVICES PROVIDED BY US, YOU ACKNOWLEDGE
          THAT YOU HAVE READ THESE TERMS OF SERVICE AND AGREE TO BE BOUND BY
          THEM.
        </div>
        <h3 className="paddingtop20">
          27. <b>Contact Us</b>
        </h3>
        <div className="fa-left-padding paddingtop20">
          Please send your feedback, comments, requests for technical support by
          email: <b>contact@head3dio.com</b>.
        </div>

        <h5 className="paddingtop20 font-weight-normal">
          These Terms of Service were created for <b>head3dio.com</b>
        </h5>
      </div>
    </>
  );
}
